import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { LabeledField } from './labeled-field.component';

import { Link } from '@/components/ui/link/link.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';

interface LocationBlockProps {
  socialName: string;
  href?: string;
  address: string;
  phone?: string;
  email?: string;
  phonePrefix?: string;
}

export function LocationBlock({
  socialName,
  href,
  address,
  phone,
  email,
  phonePrefix,
}: LocationBlockProps) {
  const name = (
    <Typography variant={TypographyVariant.BODY_TEXT} className="text-green-500 font-semibold">
      {socialName}
    </Typography>
  );

  return (
    <LabeledField label="Local">
      {href
        ? (
            <Link prefetch={false} href={href} className="w-fit" data-testid={DataTestIdEnum.APPOINTMENT_CARD_LOCATION_LINK}>
              {name}
            </Link>
          )
        : name}
      <Typography variant={TypographyVariant.BODY_TEXT} className="font-normal">
        {address}
      </Typography>
      {phone && (
        <Typography>
          {phonePrefix ? `${phonePrefix} ${phone}` : phone}
        </Typography>
      )}
      {email && <Typography className="break-words">{email}</Typography>}
    </LabeledField>
  );
}
